import { Link } from "react-router";
import { Sparkles } from "lucide-react";
import { SPONSORSHIP_CTA_CLASS } from "@/features/sponsorship/components/sponsorshipCta.styles";
import { SPONSORSHIP_PATH } from "@/features/sponsorship/routes";
import { cn } from "@/shared/utils/style.util";

type SponsorshipCtaButtonProps = { className?: string };

export const SponsorshipCtaButton = ({ className }: SponsorshipCtaButtonProps) => {
  return (
    <Link
      to={SPONSORSHIP_PATH}
      className={cn(SPONSORSHIP_CTA_CLASS, className)}
      aria-label="Recommander un CSE"
    >
      <Sparkles size={16} className="relative z-[1]" />
      <span className="relative z-[1]">Recommander un CSE</span>
    </Link>
  );
};

SponsorshipCtaButton.displayName = "SponsorshipCtaButton";
